import formInputCommonOptions from 'foundation/js/forms/formInputCommonOptions'

const options = formInputCommonOptions('FormInputGeneric', {
    validatorFunction(input) {
        return !!(input.length > 1)
    }
})

export default options